import React from 'react';
import NaturalPersonHomeApplication from './form_variants/NaturalPersonHomeApplicationComponent';
import LegalPersonHomeApplication from './form_variants/LegalPersonHomeApplicationComponent';
import HomeApplication from 'models/HomeApplication';
import { NATURAL_PERSON, LEGAL_PERSON } from 'utils/Constants';
import HomieContext from 'HomieContext';

const ALLOWED_EDIT_URLS = ['ingresos'];
type PropsType = {
  homeApplication: HomeApplication,
  langSelected: string,
  typePersonSelected: number,
  visibleFormBill: boolean,
  onHomeApplicationChange: () => void,
  onHomeApplicationCancel: () => void,
  isTheStepVisible: (number, number | null, boolean | null) => boolean,
  onNextStep: () => void,
  onPrevStep: () => void,
  prevStepText: string,
  appType: string,
  isOnlyEditIncome: boolean,
  match: any,
  history: any
};

class ApplicationSteps extends React.Component<PropsType, {}> {
  handleAllowedEditUrl = (homeApplication: any) => {
    const { history, match } = this.props;
    const { step } = match.params;
    const { currentUser } = this.context;
    if (
      !currentUser.isAdmin &&
      (homeApplication.payment &&
        homeApplication.status !== 'pending_payment' &&
        homeApplication.status !== 'pending') &&
      !ALLOWED_EDIT_URLS.includes(step)
    )
      history.push('/inquilino/aplicaciones');
  };
  render() {
    const {
      homeApplication,
      langSelected,
      typePersonSelected,
      visibleFormBill,
      onHomeApplicationChange,
      onHomeApplicationCancel,
      isTheStepVisible,
      onNextStep,
      onPrevStep,
      prevStepText,
      appType,
      isOnlyEditIncome
    } = this.props;
    this.handleAllowedEditUrl(homeApplication);
    return (
      <div>
        {typePersonSelected === NATURAL_PERSON && (
          <NaturalPersonHomeApplication
            onNextStep={onNextStep}
            onPrevStep={onPrevStep}
            langSelected={langSelected}
            homeApplication={homeApplication}
            visibleFormBill={visibleFormBill}
            typePersonSelected={typePersonSelected}
            onHomeApplicationChange={onHomeApplicationChange}
            onHomeApplicationCancel={onHomeApplicationCancel}
            isTheStepVisible={isTheStepVisible}
            prevStepText={prevStepText}
            appType={appType}
            isOnlyEditIncome={isOnlyEditIncome}
          />
        )}
        {typePersonSelected === LEGAL_PERSON && (
          <LegalPersonHomeApplication
            onNextStep={onNextStep}
            onPrevStep={onPrevStep}
            langSelected={langSelected}
            homeApplication={homeApplication}
            visibleFormBill={visibleFormBill}
            typePersonSelected={typePersonSelected}
            onHomeApplicationChange={onHomeApplicationChange}
            onHomeApplicationCancel={onHomeApplicationCancel}
            isTheStepVisible={isTheStepVisible}
            prevStepText={prevStepText}
            appType={appType}
            isOnlyEditIncome={isOnlyEditIncome}
          />
        )}
      </div>
    );
  }
}
ApplicationSteps.contextType = HomieContext;
export default ApplicationSteps;
